module.exports = __webpack_public_path__ + "img/countdown_rectangle.cb8e582b.svg";